"use client";

import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import type { ApiWave } from "@/generated/models/ApiWave";
import { useContext, useEffect, useState } from "react";
import { AuthContext } from "@/components/auth/Auth";
import WaveHeaderNameEdit from "./WaveHeaderNameEdit";
import { canEditWave } from "@/helpers/waves/waves.helpers";
export default function WaveHeaderName(t0) {
  const $ = _c(22);
  const {
    wave
  } = t0;
  const {
    connectedProfile,
    activeProfileProxy
  } = useContext(AuthContext);
  let t1;
  if ($[0] !== activeProfileProxy || $[1] !== connectedProfile || $[2] !== wave) {
    t1 = () => canEditWave({
      connectedProfile,
      activeProfileProxy,
      wave
    });
    $[0] = activeProfileProxy;
    $[1] = connectedProfile;
    $[2] = wave;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const getShowEdit = t1;
  let t2;
  if ($[4] !== getShowEdit) {
    t2 = getShowEdit();
    $[4] = getShowEdit;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const [showEdit, setShowEdit] = useState(t2);
  let t3;
  if ($[6] !== getShowEdit) {
    t3 = () => setShowEdit(getShowEdit());
    $[6] = getShowEdit;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== connectedProfile || $[9] !== wave) {
    t4 = [connectedProfile, wave];
    $[8] = connectedProfile;
    $[9] = wave;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  useEffect(t3, t4);
  const t5 = `/waves?wave=${wave.id}`;
  let t6;
  if ($[11] !== wave.name) {
    t6 = <h1 className="tw-mb-0 tw-text-lg sm:tw-text-xl tw-text-iron-50 tw-font-semibold tw-tracking-tight desktop-hover:group-hover:tw-text-iron-400 tw-transition tw-duration-300 tw-ease-out">{wave.name}</h1>;
    $[11] = wave.name;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t5 || $[14] !== t6) {
    t7 = <Link href={t5} className="tw-no-underline">{t6}</Link>;
    $[13] = t5;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== showEdit || $[17] !== wave) {
    t8 = showEdit && <div className="tw-mt-[7px] tw-size-4"><WaveHeaderNameEdit wave={wave} /></div>;
    $[16] = showEdit;
    $[17] = wave;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== t7 || $[20] !== t8) {
    t9 = <div className="tw-group tw-flex tw-items-start tw-space-x-2">{t7}{t8}</div>;
    $[19] = t7;
    $[20] = t8;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  return t9;
}